"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var SearchResultItem_1 = __importDefault(require("./SearchResultItem"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_application_1 = require("@ryerson/frontend.application");

var SearchResultItemContent_1 = require("./SearchResultItemContent");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var util_1 = require("../common/util");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var categoriesAndArticlesStyles = (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-top: 10px;\n"])));
var categoriesBoxStyles = (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\t&:first-of-type {\n\t\tmargin-right: 5px;\n\t}\n"])));
var categoriesListWrapperStyles = (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tpadding: 10px;\n"])));
var moreProductsButtonWrapper = (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tmargin-bottom: 15px;\n"])));
var ScrollResultsWrapper = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\theight: ", ";\n\toverflow-y: scroll;\n"])), function (props) {
  return props.height ? props.height + "px" : "inherit";
});
var SEARCH_RESULT_CONTAINER_HEIGHT = 728;
var MIN_CONTAINER_WINDOW_DELTA_HEIGHT = 70;
var MAX_ARTICLES = 3;

var SearchResultsDesktop = function SearchResultsDesktop(_ref) {
  var matchingProducts = _ref.matchingProducts,
      articlesResources = _ref.articlesResources,
      onMoreProducts = _ref.onMoreProducts,
      isSticky = _ref.isSticky,
      itemRef = _ref.itemRef,
      storeDirectory = _ref.storeDirectory,
      _ref$recentlyPurchase = _ref.recentlyPurchased,
      recentlyPurchased = _ref$recentlyPurchase === void 0 ? [] : _ref$recentlyPurchase,
      deliveryTimes = _ref.deliveryTimes,
      setDeliveryTimes = _ref.setDeliveryTimes,
      stateMessenger = _ref.stateMessenger,
      megaMenuProducts = _ref.megaMenuProducts,
      setSearchText = _ref.setSearchText,
      setTriggerDeliveryTimes = _ref.setTriggerDeliveryTimes;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      isLoggedIn = _ref3.user.isLoggedIn,
      language = _ref3.localization.language;

  var _ref4 = (0, frontend_common_1.useWindowSize)(),
      _ref5 = _slicedToArray(_ref4, 2),
      windowHeight = _ref5[1];

  var _ref6 = (0, react_1.useState)(),
      _ref7 = _slicedToArray(_ref6, 2),
      searchResultHeight = _ref7[0],
      setSearchResultHeight = _ref7[1];

  var hasRecentlyPurchasedItems = isLoggedIn && recentlyPurchased.length > 0;
  (0, react_1.useEffect)(function () {
    var containerWindowDelta = SEARCH_RESULT_CONTAINER_HEIGHT > windowHeight ? MIN_CONTAINER_WINDOW_DELTA_HEIGHT : Math.abs(windowHeight - SEARCH_RESULT_CONTAINER_HEIGHT);
    var stickyHightOffset = isSticky ? 145 : 220;
    var width = windowHeight - containerWindowDelta - stickyHightOffset;
    var height = width > SEARCH_RESULT_CONTAINER_HEIGHT ? SEARCH_RESULT_CONTAINER_HEIGHT : width;
    var isSingleItem = matchingProducts.length === 0 && recentlyPurchased.length <= 1;
    setSearchResultHeight(isSingleItem ? 200 : height);
  }, [windowHeight, isSticky]);
  var SearchResultsWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 13px rgba(0, 0, 0, 0.1417),\n\t\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\t\tmin-width: 483px;\n\t\tmax-width: 515px;\n\t\tposition: absolute;\n\t\tz-index: 99;\n\t\ttop: ", ";\n\t\tbackground: ", ";\n\t"])), isSticky ? "50px" : "125px", theme.colors.primary.white);
  var TypographyTitleBar = (0, styled_1.default)(frontend_typography_1.Typography)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\tbackground: ", ";\n\t\tpadding: 5px 10px;\n\t\twidth: 100%;\n\t\tdisplay: inline-block;\n\t\tcolor: ", ";\n\t"])), theme.colors.primary.darkGray, theme.colors.primary.white);

  var renderCategoriesAndArticles = function renderCategoriesAndArticles() {
    var _a;

    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      justifyContent: "space-between",
      style: categoriesAndArticlesStyles,
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
        style: categoriesBoxStyles,
        children: [(0, jsx_runtime_1.jsx)(TypographyTitleBar, {
          size: "xs",
          children: SearchResultItemContent_1.SearchResultItemContent[language].productCategories
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          gutter: 5,
          direction: "column",
          style: categoriesListWrapperStyles,
          children: megaMenuProducts === null || megaMenuProducts === void 0 ? void 0 : megaMenuProducts.map(function (_ref8, index) {
            var linkUrl = _ref8.linkUrl,
                megaMenuLinkLabel = _ref8.megaMenuLinkLabel,
                productCategoryLabel = _ref8.productCategoryLabel;
            return (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
              gatsby: false,
              to: linkUrl,
              children: (0, jsx_runtime_1.jsx)("span", {
                css: {
                  fontSize: "12px"
                },
                children: "".concat(productCategoryLabel, " ").concat(megaMenuLinkLabel).toUpperCase()
              })
            }, index);
          })
        })]
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
        style: categoriesBoxStyles,
        children: [(0, jsx_runtime_1.jsx)(TypographyTitleBar, {
          size: "xs",
          children: SearchResultItemContent_1.SearchResultItemContent[language].articlesResources
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          gutter: 5,
          direction: "column",
          style: categoriesListWrapperStyles,
          children: (_a = articlesResources === null || articlesResources === void 0 ? void 0 : articlesResources.filter(function (element, index) {
            return index < MAX_ARTICLES;
          })) === null || _a === void 0 ? void 0 : _a.map(function (_ref9, index) {
            var title = _ref9.title,
                link = _ref9.link;
            return (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
              gatsby: (0, util_1.isGatsbyLink)(false, storeDirectory),
              to: link,
              children: (0, jsx_runtime_1.jsx)("span", {
                css: {
                  fontSize: "12px"
                },
                children: title
              })
            }, "article-".concat(index));
          })
        })]
      })]
    });
  };

  var renderProductResultsSection = function renderProductResultsSection(items, sectionTitle, sliceSize) {
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
      children: [(0, jsx_runtime_1.jsx)(TypographyTitleBar, {
        size: "xs",
        children: sectionTitle
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.ContentSection, {
        children: items === null || items === void 0 ? void 0 : items.slice(0, sliceSize).map(function (item) {
          return (0, jsx_runtime_1.jsx)(SearchResultItem_1.default, {
            isMobile: false,
            item: item,
            storeDirectory: storeDirectory,
            deliveryTimes: deliveryTimes,
            setDeliveryTimes: setDeliveryTimes,
            setSearchText: setSearchText,
            setTriggerDeliveryTimes: setTriggerDeliveryTimes,
            stateMessenger: stateMessenger
          }, item.id);
        })
      }), items.length > 2 && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "center",
        alignItems: "center",
        style: moreProductsButtonWrapper,
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          size: "sm",
          variant: "outline",
          shape: "rounded",
          label: SearchResultItemContent_1.SearchResultItemContent[language].moreProducts,
          paddingType: "relaxed",
          onClick: onMoreProducts
        })
      })]
    });
  };

  var renderNoResultsFound = function renderNoResultsFound() {
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
      children: [(0, jsx_runtime_1.jsx)(TypographyTitleBar, {
        size: "xs",
        children: SearchResultItemContent_1.SearchResultItemContent[language].otherProducts
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "center",
        css: {
          height: "150px"
        },
        children: (0, jsx_runtime_1.jsx)(frontend_notification_1.Alert, {
          severity: "warn",
          size: "sm",
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            type: "primary",
            size: "sm",
            children: SearchResultItemContent_1.SearchResultItemContent[language].noResults
          })
        })
      })]
    });
  };

  return (0, jsx_runtime_1.jsxs)(SearchResultsWrapper, {
    direction: "column",
    itemRef: itemRef,
    children: [(0, jsx_runtime_1.jsxs)(ScrollResultsWrapper, {
      height: searchResultHeight,
      children: [hasRecentlyPurchasedItems && renderProductResultsSection(recentlyPurchased, SearchResultItemContent_1.SearchResultItemContent[language].recentlyPurchasedProducts, 3), !!matchingProducts.length && renderProductResultsSection(matchingProducts, SearchResultItemContent_1.SearchResultItemContent[language].otherProducts, 3), !hasRecentlyPurchasedItems && matchingProducts.length === 0 && renderNoResultsFound()]
    }), renderCategoriesAndArticles()]
  });
};

exports.default = SearchResultsDesktop;